import React, { useState } from "react";
import io from "socket.io-client";
import { FaStar } from "react-icons/fa";
import "../CSS/FeedbackForm.css";

const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

const FeedbackForm = ({
  selectedConversation,
  setSelectedConversation,
  setConversations,
}) => {
  const [rating, setRating] = useState("");
  const [resolved, setResolved] = useState("");
  const [comments, setComments] = useState("");
  const [hover, setHover] = useState(null);

  const handleMouseEnter = (index, event) => {
    const { left, width } = event.target.getBoundingClientRect();
    const x = event.clientX - left;
    const isHalf = x < width / 2;
    setHover(isHalf ? index + 0.5 : index + 1);
  };

  const handleClick = (index, event) => {
    const { left, width } = event.target.getBoundingClientRect();
    const x = event.clientX - left;
    const isHalf = x < width / 2;
    setRating(isHalf ? index + 0.5 : index + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const feedbackData = { rating, resolved, comments };
    const ticketId = selectedConversation.ticketId._id;
    const roomId = selectedConversation.roomId;

    // Emit the closeTicket event with feedback data and ticket ID
    socket.emit(
      "closeTicket",
      { ticketId, roomId, feedback: feedbackData },
      (response) => {
        if (response.success) {
          // Update the status in the current chat

          // Update the status in the current chat
          setConversations((prevConversations) =>
            prevConversations.map((conversation) =>
              conversation.roomId === roomId
                ? response.conversation
                : conversation
            )
          );

          if (selectedConversation && roomId === selectedConversation.roomId) {
            setSelectedConversation(response.conversation);
          }
        } else {
          console.error("Error closing ticket:", response.message);
          // Handle error (e.g., show an error message)
        }
      }
    );

    // Reset form
    setRating("");
    setResolved("");
    setComments("");
  };

  const handleReopen = () => {
    const newStatus = "open";
    const ticketId = selectedConversation.ticketId._id;
    const roomId = selectedConversation.roomId;

    socket.emit(
      "updateTicketStatus",
      {
        ticketId,
        status: newStatus,
        roomId: roomId,
      },
      (response) => {
        if (response.success) {

          setConversations((prevConversations) => {
            return prevConversations.map((conversation) => {
              if (conversation.roomId === roomId) {
                // Update the status of the ticketId in the selected conversation
                return {
                  ...conversation,
                  ticketId: {
                    ...conversation.ticketId,
                    status: newStatus,
                  },
                };
              }
              return conversation;
            });
          });

          if (selectedConversation && roomId === selectedConversation.roomId) {
            setSelectedConversation((prevSelectedConversation) => ({
              ...prevSelectedConversation,
              ticketId: {
                ...prevSelectedConversation.ticketId,
                status: newStatus,
              },
            }));
          }
        } else {
          console.error("Error updating ticket status:", response.message);
        }
      }
    );

    // Reset form
    setRating("");
    setResolved("");
    setComments("");
  };

  return (
    <div className="relative items-center justify-center p-4 pt-10 pb-0 border-t">
      <h2 className="dexkor-ticket-resolved-notification absolute top-2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xs p-0 text-gray-800">
        Your ticket was marked as resolved.
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-2">
          <label className="flex block text-gray-700 text-sm font-bold mb-1">
            Was your issue resolved?
          </label>
          <div className="flex">
            <label className="flex items-center mr-4">
              <input
                type="radio"
                value="Yes"
                checked={resolved === "Yes"}
                onChange={(e) => setResolved(e.target.value)}
                className="mr-1"
                required
              />
              Yes
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                value="No"
                checked={resolved === "No"}
                onChange={(e) => setResolved(e.target.value)}
                className="mr-1"
                required
              />
              No
            </label>
            {resolved === "No" && (
              <button
                onClick={handleReopen}
                className="dexkor-feedback-reopen-chat-button ml-auto"
              >
                Reopen chat
              </button>
            )}
          </div>
        </div>

        {resolved === "Yes" && (
          <>
            <div className="mb-2">
              <label className="block text-gray-700 text-sm text-left mb-1">
                <p className="font-bold">How did <span className="font-black">{selectedConversation && selectedConversation?.user?.name}</span> do for you today?</p>
              </label>
              <div className="flex space-x-1">
                {[...Array(5)].map((_, index) => (
                  <label
                    key={index}
                    className="relative flex items-center cursor-pointer"
                    onMouseMove={(event) => handleMouseEnter(index, event)}
                    onClick={(event) => handleClick(index, event)}
                    onMouseLeave={() => setHover(null)}
                  >
                    <FaStar
                      className={`text-2xl ${
                        hover >= index + 1 || rating >= index + 1
                          ? "text-yellow-500"
                          : hover >= index + 0.5 || rating >= index + 0.5
                          ? "text-yellow-500"
                          : "text-gray-300"
                      }`}
                    />
                    <FaStar
                      className="text-2xl text-gray-300"
                      style={{
                        position: "absolute",
                        clipPath: "inset(0 0 0 50%)",
                        visibility:
                          hover === index + 0.5 || rating === index + 0.5
                            ? "visible"
                            : "hidden",
                      }}
                    />
                  </label>
                ))}
              </div>
            </div>
            <div className="mb-2">
              <label className="flex block text-gray-700 text-sm font-bold mb-2">
                Comment
              </label>
              <textarea
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                rows="1"
                required
              />
            </div>
          </>
        )}

        <div className="flex items-center justify-end">
          {resolved === "Yes" && rating !== "" && (
            <button
              type="submit"
              className="dexkor-feedback-form-submit-button"
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default FeedbackForm;
